import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleFilter, handleMenu } from "../../store/layout/actions";
import { getFormattedDateRange } from "../../utils/helper";
import { CiSearch } from "react-icons/ci";
import { FaFilter } from "react-icons/fa";

const SearchBar = () => {
  const { layout } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(null);
  const [searchEvent, setSearchEvent] = useState(null);

  const handleOpenMenu = async (open) => {
    await handleMenu(open)(dispatch);
  };

  const handleDateClick = (tab) => {
    setSelectedTab(tab);
    let fromDate, toDate;

    switch (tab) {
      case "Today":
        fromDate = toDate = moment().format("YYYY-MM-DD");
        break;
      case "Tomorrow":
        fromDate = toDate = moment().add(1, "days").format("YYYY-MM-DD");
        break;
      case "Weekend":
        const today = moment();
        const nextFriday =
          today.day() <= 5 ? today.day(5) : today.add(1, "week").day(5);
        fromDate = nextFriday.format("YYYY-MM-DD");
        toDate = nextFriday.clone().add(2, "days").format("YYYY-MM-DD");
        break;
      default:
        console.error("Invalid selection");
        return;
    }
    handleFilter("date", getFormattedDateRange(fromDate, toDate))(dispatch);
  };

  const handleAction = (action, value) => {
    if (action === "search" && ["", null]?.includes(value)) return;
    handleFilter(action, value)(dispatch);
  };

  useEffect(() => {
    if (["", null]?.includes(searchEvent)) {
      handleFilter("search", null)(dispatch);
    }
  }, [dispatch, searchEvent]);

  return (
    <div className="pr-4 pt-1 ">
      <div className="flex md:hidden items-center">
        <div
          className="h-12 w-14 flex items-center justify-center rounded-md mr-1 cursor-pointer bg-[#333333]"
          onClick={() => handleOpenMenu(true)}
        >
          <FaFilter className="text-primary" size={20} />
        </div>
        <input
          type="text"
          placeholder="Search"
          className="w-full p-3 rounded-tl-md rounded-bl-md bg-[#333333] text-white placeholder-[#A3A3A3] outline-none"
          onChange={(e) => setSearchEvent(e.target.value)}
        />
        <button
          className="bg-primary text-white font-bold py-4 px-4 rounded-tr-xl rounded-br-xl transition-colors text-center"
          onClick={() => handleAction("search", searchEvent)}
        >
          <CiSearch />
        </button>
      </div>
      <div className="flex mt-4 md:mt-0 space-x-3 overflow-x-auto w-full">
        {["Today", "Tomorrow", "Weekend"].map((tab) => (
          <button
            key={tab}
            className={`${
              layout?.filterByDate !== null && selectedTab === tab
                ? "bg-primary hover:bg-blue-700"
                : "dark:bg-[#24262a] dark:hover:bg-[#232428]"
            } px-4 py-1 mb-2 lg:mb-0 text-white  rounded-full transition duration-200`}
            onClick={() => handleDateClick(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SearchBar;
